export default "__VITE_ASSET__a7949f40__"